import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Toast from "./Toast";
import { hideToast } from "../../redux/toastSlice";

const ToastProvider = () => {
    const toasts = useSelector((state) => state.toast.toasts);
    const dispatch = useDispatch();
    const timeoutsRef = useRef({});

    useEffect(() => {
        toasts.forEach(toast => {
            if (!timeoutsRef.current[toast.id]) {
                timeoutsRef.current[toast.id] = setTimeout(() => {
                    dispatch(hideToast(toast.id));
                    delete timeoutsRef.current[toast.id];
                }, toast.duration || 3000);
            }
        });

        // Cleanup on unmount
        return () => {
            Object.values(timeoutsRef.current).forEach(clearTimeout);
            timeoutsRef.current = {};
        };
    }, [toasts, dispatch]);

    if (!toasts.length) return null;

    return (
        <div style={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 2000,
            display: "flex",
            flexDirection: "column",
            gap: "12px"
        }}>
            {toasts.map(toast => (
                <Toast
                    key={toast.id}
                    message={toast.message}
                    type={toast.type}
                    onClose={() => {
                        dispatch(hideToast(toast.id));
                        if (timeoutsRef.current[toast.id]) {
                            clearTimeout(timeoutsRef.current[toast.id]);
                            delete timeoutsRef.current[toast.id];
                        }
                    }}
                />
            ))}
        </div>
    );
};

export default ToastProvider;
